import { render, staticRenderFns } from "./Sure2023.vue?vue&type=template&id=42d24d28&scoped=true&"
import script from "./Sure2023.vue?vue&type=script&lang=js&"
export * from "./Sure2023.vue?vue&type=script&lang=js&"
import style0 from "./Sure2023.vue?vue&type=style&index=0&id=42d24d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d24d28",
  null
  
)

export default component.exports